import { Injectable } from '@angular/core';

@Injectable()
export class DateFormatService {

    private isoFormat = /(\d{4})-(\d{2})-(\d{2})T(\d{2})\:(\d{2})\:(\d{2})[+-](\d{2})\:(\d{2})/;
    /**
     * Extrai a hora de uma representação de dateTime
     * @param representation representação em formato 2019-01-21T18:00:00-02:00
     */
    public extractTimeFromDateTime(representation: string) {

        if (!this.isoFormat.test(representation)) {
            return null;
        }

        const time = representation
            .split('T')
            .pop();

        return time.split('-')[0]
            .substring(0, 5);
    }
}
